import React, { useState, useEffect, Component } from "react";
import { Col, Row, Alert, Button } from "react-bootstrap";
import { FaRegListAlt, FaQuestionCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import AllActivities from "../../../Components/AllActivities";
import NewResumesList from "../../../Components/ResumesList";
import MessagesList from "../../../Components/MessagesList";
import {
  getResumesList,
  getPublicResumes,
  getPublicResumeListForEmpDashboard,
} from "../../../Services/ResumeService";
import { getRecentMessagesForEmployer } from "../../../Services/MessagesService";
import getAllActivities from "../../../Services/AllActivities";
import {
  recentActivityPerPage,
  recentMessagesPerPage,
  recentPublicResumePerPage,
} from "../../../Utilities/Helper";
import { toast } from "react-toastify";
import SpinnerLoader from "../../../Components/SpinnerLoader";
import { get } from "../../../Services/AxiosService";
import { getUserDetailsAPI } from "../../../Utilities/APIHelper";
import TermsReacceptanceModal from "../../../Components/Shared/TermsReacceptanceModal";
import { useTermsAcceptance } from "../../../hooks/useTermsAcceptance";

export default function Dashboard() {
  const [RecentActivities, setActivities] = useState([]);
  const [NewResumes, setNewResumes] = useState([]);
  const [Messages, setMessages] = useState([]);

  // getting jobs list list
  const [showSpinnerForActivities, setShowSpineerForActivities] =
    useState(true);
  const [showSpinnerForMessages, setShowSpineerForMessages] = useState(true);

  const [refresh, setRefresh] = useState(false);
  const [showSpinner, setShowSpinner] = useState(true);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [showHelp, setShowHelp] = useState(false);

  // Terms acceptance functionality
  const {
    showTermsModal,
    termsAccepted,
    acceptTerms,
    declineTerms,
    openTermsInNewWindow,
    currentTermsVersion,
  } = useTermsAcceptance(email);

  useEffect(() => {
    async function activitiesData() {
      getAllActivities("recordperpage=" + recentActivityPerPage)
        .then((res) => {
          const result = JSON.parse(res.response);
          const data = result.userActivity;
          setActivities(data);
          setShowSpineerForActivities(false);
        })
        .catch((err) => {
          console.log("Activity: ", err);
          setShowSpineerForActivities(false);
        });
    }
    activitiesData();
  }, [refresh]);

  // getting resume list
  useEffect(() => {
    async function resumesData() {
      getPublicResumeListForEmpDashboard(
        `?recordperpage=${recentPublicResumePerPage}`
      )
        .then((res) => {
          const result = res;
          setNewResumes(result.jinTemplatesModelList);
          setShowSpinner(false);
        })
        .catch((err) => {
          console.log("Resume: ", err);
          setShowSpinner(false);
        });
    }
    resumesData();
  }, [refresh]);

  useEffect(() => {
    async function getName() {
      get(getUserDetailsAPI)
        .then((res) => {
          // console.log(res.data.response);
          let response = res.data.response;
          setName(response.firstName);
          setEmail(response.email);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    getName();
  }, [refresh]);

  const refreshTable = () => {
    setShowSpinner(true);
    setRefresh((prev) => !prev);
  };

  // getting message list
  useEffect(() => {
    async function messagesData() {
      getRecentMessagesForEmployer("?recordperpage=" + recentMessagesPerPage)
        .then((res) => {
          var result = JSON.parse(res.response);
          var resultArray = [];
          result.forEach((element) => {
            var obj = {};
            obj.name = element.fullName;
            obj.text = element.jobSeekerSponshirShipMsg;
            obj.date = element.createdDate;
            obj.profilePhoto = element.profilePhoto;
            resultArray.push(obj);
          });
          setMessages(resultArray);
          setShowSpineerForMessages(false);
        })
        .catch((err) => {
          console.log("Message: ", err);
          setShowSpineerForMessages(false);
        });
    }
    messagesData();
  }, []);

  return (
    <div className="container p-0">
      <TermsReacceptanceModal
        show={showTermsModal}
        onAccept={acceptTerms}
        onDecline={declineTerms}
        onOpenTerms={openTermsInNewWindow}
        currentVersion={currentTermsVersion}
      />
      <h1 className="page-title">
        Hello {name} <small>(Employer)</small>
        <Button
          variant="link"
          className="p-0 ml-3 d-inline-flex align-items-center"
          onClick={() => setShowHelp(!showHelp)}
          title="Welcome Information"
        >
          <FaQuestionCircle size={24} className="text-info" />
          <span className="text-info ml-2" style={{ fontSize: '1rem', fontWeight: 'normal' }}>Help</span>
        </Button>
      </h1>

      {/* Show welcome message when no activities, messages, or resumes exist and loading is complete OR when help button is clicked */}
      {((RecentActivities.length === 0 &&
        Messages.length === 0 &&
        NewResumes.length === 0 &&
        !showSpinnerForActivities &&
        !showSpinnerForMessages &&
        !showSpinner) ||
        showHelp) && (
          <Alert
            variant="info"
            className="my-4"
            dismissible={showHelp}
            onClose={() => setShowHelp(false)}
          >
            <Alert.Heading>Welcome to JobInfoNetwork!</Alert.Heading>
            <p>
              Get started with these steps to find the right candidates for your organization:
            </p>
            <h5>Step 1: Post Your Job Openings</h5>
            <p>
              Your posted jobs will be sent to all job seekers who have requested job postings in your industries. In addition, your postings will be sent to employed JobInfoNetwork participants who are assisting job seekers and have also requested job postings in their industry.
            </p>
            <h5>Step 2: Review Resumes</h5>
            <p>
              Browse through the posted resumes of job seekers who are actively looking for opportunities in your industry. You can save interesting profiles for later review and reach out to promising candidates directly.
            </p>
            <h5>Step 3: Receive Resumes in Your Selected Industries</h5>
            <p className="mb-0">
              In your “Account Information” be sure and check the box to “Receive emails of newly posted resumes in your selected industries”. That way, when a new job seeker registers and posts a resume in one of your industries, it will come directly to you.
            </p>
          </Alert>
        )}
      <div className="dashboard-wrapper">
        <Row>
          <Col md={7}>
            <div className="dashboard-box activity dashboard-col-bg">
              <h2 className="page-sub-title">Recent Activity</h2>
              <AllActivities
                activities={RecentActivities}
                showSpinner={showSpinnerForActivities}
              />
              <Link
                className="btn btn-warning btn-xs white mt-3"
                to={`${process.env.PUBLIC_URL}/employer/activitieslist`}
              >
                <span className="icon icon-list_alt mr-3"></span> View more
              </Link>
            </div>

            <div className="dashboard-box activity dashboard-col-bg mt-5">
              <h2 className="page-sub-title">Messages</h2>
              <MessagesList
                messages={Messages}
                showSpinner={showSpinnerForMessages}
              />
              <Link
                to={`${process.env.PUBLIC_URL}/employer/messages`}
                className="btn btn-warning btn-xs white mt-3"
              >
                <span className="icon icon-chat_bubble_outline mr-3"></span>{" "}
                View all messages
              </Link>
            </div>
          </Col>
          <Col md={5}>
            <div className="dashboard-box resume dashboard-col-bg">
              <h2 className="page-sub-title">New Public Resumes</h2>
              {showSpinner && <SpinnerLoader />}
              {NewResumes.length === 0 && !showSpinner && (
                <h5 style={{ textAlign: "center" }}>No Data Found</h5>
              )}
              <NewResumesList
                resumes={NewResumes}
                saveResumeChange={refreshTable}
                showSpinner={showSpinner}
              />
              <Link
                to={`${process.env.PUBLIC_URL}/resumes`}
                className="btn btn-warning btn-xs white mt-3"
              >
                <span className="icon icon-file_present mr-3"></span> View all
                Public resumes
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

// export default Dashboard;
